import React, {FC, useCallback, useEffect, useRef, useState} from 'react'
import {StepperComponent} from '../../../../_metronic/assets/ts/components'
import {Form, Formik, FormikValues} from 'formik'
import {
  ICreateAccount,
  createAccountSchemas,
  inits,
} from '../../wizards/components/CreateAccountWizardHelper'
import {Step1} from '../../wizards/components/steps/Step1'
import {Step2} from '../../wizards/components/steps/Step2'
import {Step4} from '../../wizards/components/steps/Step4'
// import {Step5} from '../../wizards/components/steps/Step5'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Link, useNavigate} from 'react-router-dom'
import {Step6} from '../../wizards/components/steps/Step6'
// import Step3 from '../../wizards/components/steps/Step3'
import OTP from '../../wizards/components/steps/Step3'
import {Step7} from '../../wizards/components/steps/Step7'
import {Step8} from '../../wizards/components/steps/Step8'
import {Step9} from '../../wizards/components/steps/Step9'
import {Step10} from '../../wizards/components/steps/Step10'
import {Step11} from '../../wizards/components/steps/Step11'
import register from './server/Step1/index'
// import {currentSteps} from './middleware'
// import {handleFormatText} from './middleware/ChangeText'
// import listBank from './server/Steps9'
// import {StepFrontCccd} from '../../wizards/components/steps/Step4-1'
// import {StepBackCccd} from '../../wizards/components/steps/Step4-2'
import {Step7ScanFace} from '../../wizards/components/steps/Step7-scanface'
import {formatBirth, formatDate} from '../../../utils/format'
// import checkStatusAccount from './server/Step5'
import {showToast} from './middleware/showToast'
import {ModalReaded} from '../../wizards/components/steps/ModalReaded'
import {getFile} from './middleware/converseBase64'
import uploadCccd from './server/Step4-1'
import {getAcconutInfo, getToken, updateAccount} from './server/UpdateAccount'
import {newLineToSpace} from './middleware/newLineToSpace'
import Swal from 'sweetalert2'
import {otpVerify} from './server/OTP'
import {getCookie, removeCookie, setCookie} from '../../../utils/cookie'
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3'
import {sendStepLog} from './server/UserLog'

const Registration: FC = () => {
  const {executeRecaptcha} = useGoogleReCaptcha()
  const recaptchaKey = process.env.REACT_APP_RECAPTCHA_ACTION
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<any>(null)
  const [currentSchema, setCurrentSchema] = useState(createAccountSchemas[0])
  const [initValues] = useState<ICreateAccount>(inits)
  const [isSubmitButton, setSubmitButton] = useState(false)
  const [currentStep, setCurrentStep] = useState<any>()
  const [valueSteps, setValueSteps] = useState<any>()
  const [valueOSSEQ, setValueOSSEQ] = useState<any>()
  const [eKYCRes, seteKYCRes] = useState<any>()
  const [activeStep, setActiveStep] = useState(false)
  // Chỉ số step đang hiển thị (đồng bộ với stepper) — dùng để các step con biết khi nào mình được mở lại
  const [stepIndex, setStepIndex] = useState(1)
  const [acitveStepOTP, setAcitveStepOTP] = useState(false)
  const [asdBank, setAsdBank] = useState(false)
  const [checkedFinal, setCheckedFinal] = useState()
  const [submitModal, setSubmitModal] = useState()
  const [getValInfo, setGetValInfo] = useState()
  const [getValCare, setGetValCare] = useState()
  const [listBank, setListBank] = useState([])
  const [listBankBr, setListBankBr] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [loading1, setLoading1] = useState(false)
  const pendingStep1Log = useRef<Record<string, any> | null>(null)
  const userContactRef = useRef<{mobile?: string; email?: string; idno?: string}>({})
  const [checkOtp, setCheckOtp] = useState(false)
  const [checkOtpSucc, setCheckOtpSucc] = useState(false)
  const [getValOtp, setGetValOtp] = useState()
  const [disableStep, setDisableStep] = useState(false)
  const [emptyOtp, setEmtyOtp] = useState(false)
  const [isVietNam, setIsVietNam] = useState(true)
  const [getTokenVNPT, setGetTokenVNPT] = useState({})
  const [saveCaptcha, setSaveCaptcha] = useState('')
  const history = useNavigate()

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  // Memoized: getCookie + sendStepLog are stable imports, userContactRef is a stable ref.
  // Stable reference prevents useEffect([onGetData, resEKYC]) in Step7ScanFace from re-firing.
  const logStep = useCallback((stepIndex: number, data: Record<string, any> = {}) => {
    try {
      const sessionID = getCookie('SESSION_ID')
      if (!sessionID) return
      sendStepLog(sessionID, stepIndex, data, userContactRef.current)
    } catch {}
  }, [])

  // Create an event handler so you can call the verification on button click event or form submit
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available')
      return
    }

    const token = await executeRecaptcha(recaptchaKey)
    setSaveCaptcha(token)
    // console.log(token)
  }, [executeRecaptcha])

  // useEffect(() => {
  //   handleReCaptchaVerify()
  // }, [handleReCaptchaVerify])

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    setDisableStep(false)
    stepper.current.goPrev()
    setStepIndex(stepper.current.currentStepIndex)
    setCurrentSchema(createAccountSchemas[stepper.current.currentStepIndex - 1])
    if (stepper.current.currentStepIndex === 1) {
      setAcitveStepOTP(false)
      setCheckOtp(false)
      setCheckOtpSucc(false)
      setEmtyOtp(false)
    }
    if (stepper.current.currentStepIndex === 3) {
      setDisableStep(true)
    }
    setSubmitButton(stepper.current.currentStepIndex === stepper.current.totalStepsNumber)
    setActiveStep(false)
  }

  const submitStep = async (values: ICreateAccount, actions: FormikValues) => {
    values = {...values, occupation: values.occupation.trim()}
    setValueSteps(values)
    if (!stepper.current) {
      return
    }
    setDisableStep(false)
    let asd = false

    if (stepper.current.currentStepIndex === 1) {
      try {
        setLoading(true)
        // Get reCAPTCHA token first
        if (!executeRecaptcha) {
          showToast('ReCAPTCHA not available', 1500, 'error')
          return
        }
        const captchaToken = await executeRecaptcha(recaptchaKey)
        setSaveCaptcha(captchaToken)

        // Now use the token directly in the API call
        const {data_list, error_code, error_desc} = await register({
          email: values.personalEmail,
          mobile: values.phoneNumber.toString(),
          grp_tp: values.investors,
          source: '2',
          recaptchaToken: captchaToken,
        })

        if (error_code === '0000') {
          setLoading(false)
          asd = true
          stepper.current.goNext()
          setAcitveStepOTP(true)
          setEmtyOtp(true)
          showToast('Create success', 1500, 'success')
          setValueOSSEQ(data_list[0].os_seq_no)
          userContactRef.current = {
            mobile: values.phoneNumber?.toString(),
            email: values.personalEmail,
          }
          pendingStep1Log.current = {
            email: values.personalEmail,
            mobile: values.phoneNumber,
            grp_tp: values.investors,
            nationality: values.static,
            tax_cd: values.tax_cd,
            occupation: values.occupation,
            os_seq_no: data_list[0]?.os_seq_no,
          }
          // ============================================================
          // LOG STEP 0 — PERSONAL_DATA_PROCESSING_CONSENT
          // Trigger: nhấn Tiếp theo tại màn nhập thông tin cá nhân (Step2)
          // sessionID: null (chưa có tại bước này)
          // ============================================================
          sendStepLog(null, 0, {
            mobile: values.phoneNumber?.toString(),
            email: values.personalEmail,
            nationality: values.static,
            grp_tp: values.investors,
            tax_cd: values.tax_cd,
            occupation: values.occupation,
            os_seq_no: data_list[0]?.os_seq_no,
          }, userContactRef.current)
        } else if (error_code === '1005') {
          // showToast(error_desc, 2000, 'error')
          setLoading(false)
          Swal.fire({
            title:
              error_desc == 'Số điện thoại bị khoá do nhập sai OTP nhiều lần'
                ? 'Số điện thoại bị khoá do nhập sai OTP nhiều lần'
                : error_desc ==
                  'Quý khách đã vượt quá số lần nhận OTP. Vui lòng thử lại sau 24h kể từ thời điểm bị khóa'
                ? 'Quý khách đã vượt quá số lần nhận OTP. Vui lòng thử lại sau 24h kể từ thời điểm bị khóa'
                : 'Số điện thoại đã tồn tại',

            icon: 'info',
            confirmButtonText: 'Đã hiểu',
          })
          setCurrentStep(stepper.current.currentStepIndex(1))
          setActiveStep(true)
        } else if (error_code === '1006') {
          setLoading(false)
          Swal.fire({
            title: 'Số điện thoại không đúng định dạng',
            icon: 'error',
            confirmButtonText: 'Đã hiểu',
          })
          setCurrentStep(stepper.current.currentStepIndex(1))
          setActiveStep(true)
        }
        handleReCaptchaVerify()
      } catch (error: any) {
        asd = false
        setLoading(false)
        if (error.response.status === 500) {
          showToast('Liên hệ Admin', 1500, 'error')
          setActiveStep(true)
        } else {
          showToast(error.response.data.error_desc, 2000, 'error')
        }
      }
      setActiveStep(true)
    }
    if (stepper.current.currentStepIndex === 2) {
      if (!asd) {
        try {
          setLoading(true)
          const otpRes = await otpVerify({
            mobile: valueSteps?.phoneNumber,
            otp: getValOtp,
          })
          if (otpRes?.error_code === '0000') {
            setLoading(false)
            showToast(otpRes?.error_desc, 1500, 'success')
            setCheckOtp(false)
            setCheckOtpSucc(true)
            setDisableStep(true)
            const sessionID = otpRes?.data_list[0]?.sessionID
            setCookie('SESSION_ID', sessionID)
       
            pendingStep1Log.current = null
            // ============================================================
            // LOG STEP 3 — "Màn hướng dẫn chụp CCCD"
            // Trigger: OTP verify thành công, goNext() vào màn hướng dẫn CCCD
            // Data: email, mobile, grp_tp, os_seq_no từ bước đăng ký
            // ============================================================
            sendStepLog(sessionID, 3, {
              email: valueSteps?.personalEmail,
              occupation: valueSteps?.occupation,
              mobile: valueSteps?.phoneNumber,
              tax_cd: valueSteps?.tax_cd,
              nationality: valueSteps?.static,
            }, userContactRef.current)
          } else if (otpRes?.error_code !== '0000') {
            setLoading(false)
            stepper.current.goPrev()
            showToast(otpRes?.error_desc, 1500, 'error')
            if (otpRes?.error_desc === 'Sai OTP quá số lần quy định. Tài khoản đã bị khoá') {
              Swal.fire({
                title: 'Nhập sai mã OTP quá 3 lần',
                allowOutsideClick: false,
                html: `Mời quý khách đến Chi nhánh/ Phòng giao dịch của NHSV để thực hiện mở tài khoản hoặc liên hệ <b>19001055</b> để được hỗ trợ.`,
                icon: 'error',
                confirmButtonText: 'Đã hiểu',
              }).then((result) => {
                if (result.isConfirmed) {
                  // eslint-disable-next-line no-restricted-globals
                  location.reload()
                  removeCookie('SESSION_ID')
                }
              })
            }
            setCheckOtp(true)
            setCheckOtpSucc(false)
          }
        } catch (error) {
          setLoading(false)
          console.log(error)
          Swal.fire({
            title: 'Liên hệ admin',
            allowOutsideClick: false,
            html: `Vui lòng liên hệ NHSV theo số <b>19001055</b> để biết thêm chi tiết.`,
            icon: 'error',
            confirmButtonText: 'Đã hiểu',
          }).then((result) => {
            if (result.isConfirmed) {
              // eslint-disable-next-line no-restricted-globals
              location.reload()
              removeCookie('SESSION_ID')
            }
          })
        }
      }
      // setDisableStep(true)
    }

    if (stepper.current.currentStepIndex === 3) {
      try {
        setLoading(true)
        const otpRes = await getToken()
        setGetTokenVNPT(otpRes)
        setLoading(false)
      } catch (error) {
        setLoading(false)
        Swal.fire({
          title: 'Liên hệ admin',
          allowOutsideClick: false,
          html: `Vui lòng liên hệ NHSV theo số <b>19001055</b> để biết thêm chi tiết.`,
          icon: 'error',
          confirmButtonText: 'Đã hiểu',
        }).then((result) => {
          if (result.isConfirmed) {
            // eslint-disable-next-line no-restricted-globals
            location.reload()
            removeCookie('SESSION_ID')
          }
        })
      }
    }

    if (stepper.current.currentStepIndex === 4) {
      setActiveStep(true)
      if (eKYCRes && activeStep === false) {
        setActiveStep(false)
      }
    }

    if (stepper.current.currentStepIndex === 5) {
      setActiveStep(false)
    }

    if (stepper.current.currentStepIndex === 6) {
      setActiveStep(true)
      if (
        values.brch_cd &&
        values.ifno_idno &&
        values.acnt_mrgn_tp &&
        valueSteps.sms_tp &&
        activeStep === false
      ) {
        setActiveStep(false)
      }
    }

    if (stepper.current.currentStepIndex === 7) {
      setActiveStep(true)
      setAsdBank(true)
      if (
        values.bank_cd_off_1 &&
        values.bank_brch_cd_1 &&
        values.bank_acnt_no_1 &&
        activeStep === false
      ) {
        setActiveStep(false)
      }
    }

    if (stepper.current.currentStepIndex !== stepper.current.totalStepsNumber) {
      if (!asd) {
        const currentIndex = stepper.current.currentStepIndex
        const nextStepIndex = currentIndex + 1
        stepper.current.goNext()
        setStepIndex(stepper.current.currentStepIndex)
        setCurrentStep(stepper.current)
        // steps 4,5: no log (navigation only). step 6: logged in handleChildScanRes.
        // steps 7-10: log only fields filled at that specific step.
        if (nextStepIndex >= 7 && nextStepIndex <= 10) {
          let stepData: Record<string, any> = {}

          if (currentIndex === 6) {
            // ============================================================
            // LOG STEP 7 — "Nhập thông tin cá nhân"
            // Trigger: nhấn Tiếp theo tại màn Xác nhận thông tin eKYC (Step6)
            // ============================================================
            stepData = {
              idno: values.idno,
              idno_iss_dt: values.idno_iss_dt,
              idno_iss_orga: values.idno_iss_orga,
              cust_nm: values.cust_nm,
              birth_dt: values.birth_dt,
              sex_tp: values.sex_tp,
              home_addr: values.home_addr,
              conct_addr: values.conct_addr,
              accuracy: values.accuracy,
              fatca_yn: values.fatca_yn,
            }
          } else if (currentIndex === 7) {
            // ============================================================
            // LOG STEP 8 — "Nhập thông tin tài khoản"
            // Trigger: nhấn Tiếp theo tại màn Đăng ký dịch vụ bổ sung (Step8)
            // ============================================================
            stepData = {
              brch_cd: values.brch_cd,
              sms_tp: values.sms_tp,
              rcm_emp_no_tp: values.rcm_emp_no_tp,
              ifno_idno: values.ifno_idno,
              mng_emp_yn: values.mng_emp_yn,
              mng_emp_no: values.mng_emp_no,
              acnt_mrgn_tp: values.acnt_mrgn_tp,
              acnt_dr_tp: values.acnt_dr_tp,
              trd_onl_yn: values.trd_onl_yn,
              cert_tp: values.cert_tp,
              otp_recv_tp: values.otp_recv_tp,
              auto_pia_tp: values.auto_pia_tp,
              email_yn: values.email_yn,
            }
          } else if (currentIndex === 8) {
            // ============================================================
            // LOG STEP 9 — "Nhập thông tin ngân hàng"
            // Trigger: nhấn Tiếp theo tại màn Liên kết ngân hàng (Step9)
            // ============================================================
            stepData = {
              bank_cd_off_1: values.bank_cd_off_1,
              bank_brch_cd_1: values.bank_brch_cd_1,
              bank_acnt_no_1: values.bank_acnt_no_1,
              bank_cd_off_2: values.bank_cd_off_2,
              bank_brch_cd_2: values.bank_brch_cd_2,
              bank_acnt_no_2: values.bank_acnt_no_2,
              bank_cd_off_3: values.bank_cd_off_3,
              bank_brch_cd_3: values.bank_brch_cd_3,
              bank_acnt_no_3: values.bank_acnt_no_3,
            }
          } else if (currentIndex === 9) {
            // ============================================================
            // LOG STEP 10 — "Nhập thông tin đầu tư"
            // Trigger: nhấn Tiếp theo tại màn Thông tin đầu tư (Step10)
            // ============================================================
            stepData = {
              ivmt_goal_tp: values.ivmt_goal_tp,
              risk_tp: values.risk_tp,
              exp_yn: values.exp_yn,
              customerIsAnInternal: values.customerIsAnInternal,
              internal_cpny_nm_1: values.internal_cpny_nm_1,
              internal_stk_1: values.internal_stk_1,
              internal_position_1: values.internal_position_1,
              internal_cpny_nm_2: values.internal_cpny_nm_2,
              internal_stk_2: values.internal_stk_2,
              internal_position_2: values.internal_position_2,
              internal_cpny_nm_3: values.internal_cpny_nm_3,
              internal_stk_3: values.internal_stk_3,
              internal_position_3: values.internal_position_3,
              customersOwnHave5: values.customersOwnHave5,
              own_cpny_nm_1: values.own_cpny_nm_1,
              own_stk_1: values.own_stk_1,
              own_position_1: values.own_position_1,
              own_cpny_nm_2: values.own_cpny_nm_2,
              own_stk_2: values.own_stk_2,
              own_position_2: values.own_position_2,
              own_cpny_nm_3: values.own_cpny_nm_3,
              own_stk_3: values.own_stk_3,
              own_position_3: values.own_position_3,
              informationAboutoOners: values.informationAboutoOners,
              bo_fullname: values.bo_fullname,
              bo_dob: values.bo_dob,
              bo_nationality: values.bo_nationality,
              bo_idno: values.bo_idno,
              bo_idno_iss_dt: values.bo_idno_iss_dt,
              bo_idno_iss_orga: values.bo_idno_iss_orga,
              bo_home_addr: values.bo_home_addr,
              bo_conct_addr: values.bo_conct_addr,
              bo_job: values.bo_job,
              bo_position: values.bo_position,
              bo_phone_no: values.bo_phone_no,
              bo_visa_no: values.bo_visa_no,
              bo_visano_iss_orga: values.bo_visano_iss_orga,
              bo_foreign_residence: values.bo_foreign_residence,
            }
          }

          logStep(nextStepIndex, stepData)
        }
      }
    } else {
      localStorage.setItem(
        'id_no',
        values.idno ? values.idno : newLineToSpace(eKYCRes?.ocr.object.id)
      )
      setLoading(true)
      const callAPIWithDelay = async () => {
        const maxAttempts = 5
        let attempts = 0
        while (attempts < maxAttempts) {
          try {
            const {error_code} = await getAcconutInfo({
              idno: values.idno ? values.idno : newLineToSpace(eKYCRes?.ocr.object.id),
            })
            if (error_code === '0000') {
              break
            } else if (error_code === '1005') {
              attempts++
              const delay = Math.min(4000, 2 ** attempts * 1000)
              await new Promise((resolve) => setTimeout(resolve, delay))
            }
          } catch (error: any) {
            if (error.response?.status === 504) {
              attempts++
              const delay = Math.min(4000, 2 ** attempts * 1000)
              await new Promise((resolve) => setTimeout(resolve, delay))
            } else {
              setLoading(false)
              Swal.fire({
                title: 'Liên hệ admin',
                html: `Vui lòng liên hệ NHSV theo số <b>19001055</b> để được hỗ trợ.`,
                allowOutsideClick: false,
                icon: 'error',
                confirmButtonText: 'Đã hiểu',
              }).then((result) => {
                if (result.isConfirmed) {
                  history('/auth')
                }
              })
              return
            }
          }
        }
        setLoading(false)
        if (attempts === maxAttempts) {
          Swal.fire({
            title: 'Liên hệ admin',
            html: `Vui lòng liên hệ NHSV theo số <b>19001055</b> để được hỗ trợ.`,
            allowOutsideClick: false,
            icon: 'error',
            confirmButtonText: 'Đã hiểu',
          }).then((result) => {
            if (result.isConfirmed) {
              history('/auth')
            }
          })
        }
      }

      const temp: any = getFile(eKYCRes?.base64_doc_img.img_front, 'mattruoc')
      const temp2: any = getFile(eKYCRes?.base64_doc_img.img_back, 'matsau')
      const formDataFront = buildFormData(
        temp,
        '2',
        values.idno ? values.idno : newLineToSpace(eKYCRes?.ocr.object.id)
      )
      const formDataBack = buildFormData(
        temp2,
        '3',
        values.idno ? values.idno : newLineToSpace(eKYCRes?.ocr.object.id)
      )
      await updateAccount({
        ...values,
        tax_cd: values.tax_cd
          ? values.tax_cd
          : values.idno
          ? values.idno
          : newLineToSpace(eKYCRes?.ocr.object.id),
        auto_pia_tp: values.auto_pia_tp ? 'Y' : 'N',
        trd_onl_yn: values.trd_onl_yn ? 'Y' : 'N',
        cert_tp: values.cert_tp ? '1' : '2',
        otp_recv_tp: values.otp_recv_tp ? 'Y' : 'N',
        email_yn: values.email_yn ? 'Y' : 'N',
        // acnt_mrgn_tp (Ký quỹ/Margin), acnt_dr_tp (Phái sinh) là checkbox boolean → BE cần '1' (có) / '2' (không)
        acnt_mrgn_tp: values.acnt_mrgn_tp ? '2' : '1',
        acnt_dr_tp: values.acnt_dr_tp ? '2' : '1',
        // job_detail: BE yêu cầu, map từ nghề nghiệp nhập ở Step2
        job_detail: values.occupation,
        brch_cd: values.brch_cd ? values.brch_cd : '100',
        cust_nm: newLineToSpace(values.cust_nm)
          ? newLineToSpace(values.cust_nm)
          : newLineToSpace(eKYCRes?.ocr.object.name),
        bank_acnt_nm_1: newLineToSpace(eKYCRes?.ocr.object.name),
        bank_acnt_nm_2: values.bank_cd_off_2 ? newLineToSpace(eKYCRes?.ocr.object.name) : undefined,
        bank_acnt_nm_3: values.bank_cd_off_3 ? newLineToSpace(eKYCRes?.ocr.object.name) : undefined,
        bank_nm_1: values.bank_cd_off_1 ? onChangeHandler(values.bank_cd_off_1) : undefined,
        bank_nm_2: values.bank_cd_off_2 ? onChangeHandler(values.bank_cd_off_2) : undefined,
        bank_nm_3: values.bank_cd_off_3 ? onChangeHandler(values.bank_cd_off_3) : undefined,
        bank_brch_nm_1: values.bank_brch_cd_1
          ? onChangeHandlerBr(values.bank_brch_cd_1)
          : undefined,
        bank_brch_nm_2: values.bank_brch_cd_2
          ? onChangeHandlerBr1(values.bank_brch_cd_2)
          : undefined,
        bank_brch_nm_3: values.bank_brch_cd_3
          ? onChangeHandlerBr2(values.bank_brch_cd_3)
          : undefined,
        idno: values.idno ? values.idno : newLineToSpace(eKYCRes?.ocr.object.id),
        idno_iss_orga: newLineToSpace(values.idno_iss_orga)
          ? newLineToSpace(values.idno_iss_orga)
          : newLineToSpace(eKYCRes?.ocr.object.issue_place),
        vnpt_point: eKYCRes?.compare.object.prob.toString(),
        seq_no: valueOSSEQ,
        birth_dt: values.birth_dt
          ? formatDate(values.birth_dt)
          : formatBirth(eKYCRes?.ocr.object.birth_day),
        sex_tp: values.sex_tp ? values.sex_tp : eKYCRes?.ocr.object.gender === 'Nam' ? '1' : '2',
        partner_nm: getValInfo ? getValInfo : undefined,
        mng_emp_nm: getValCare ? getValCare : undefined,
        idno_iss_dt: values.idno_iss_dt
          ? formatDate(values.idno_iss_dt)
          : formatBirth(eKYCRes?.ocr.object.issue_date),
        bo_dob: values.bo_dob ? formatDate(values.bo_dob) : undefined,
        bo_idno_iss_dt: values.bo_idno_iss_dt ? formatDate(values.bo_idno_iss_dt) : undefined,
        home_addr: newLineToSpace(values.home_addr)
          ? newLineToSpace(values.home_addr)
          : newLineToSpace(eKYCRes?.ocr.object.recent_location),
        conct_addr: newLineToSpace(values.conct_addr)
          ? newLineToSpace(values.conct_addr)
          : newLineToSpace(values.home_addr)
          ? newLineToSpace(values.home_addr)
          : newLineToSpace(eKYCRes?.ocr.object.recent_location),
        notif_yn: 'N',
        fatca_yn: values.fatca_yn ? 'Y' : 'N',
        send_email_cntr_yn: 'N',
        internal_cpny_nm_1: values.internal_cpny_nm_1 ? values.internal_cpny_nm_1 : undefined,
        internal_cpny_nm_2: values.internal_cpny_nm_2 ? values.internal_cpny_nm_2 : undefined,
        internal_stk_1: values.internal_stk_1 ? values.internal_stk_1 : undefined,
        internal_stk_2: values.internal_stk_2 ? values.internal_stk_2 : undefined,
        internal_position_1: values.internal_position_1 ? values.internal_position_1 : undefined,
        internal_position_2: values.internal_position_2 ? values.internal_position_2 : undefined,
        own_cpny_nm_1: values.own_cpny_nm_1 ? values.own_cpny_nm_1 : undefined,
        own_cpny_nm_2: values.own_cpny_nm_2 ? values.own_cpny_nm_2 : undefined,
        own_stk_1: values.own_stk_1 ? values.own_stk_1 : undefined,
        own_stk_2: values.own_stk_2 ? values.own_stk_2 : undefined,
        own_position_1: values.own_position_1 ? values.own_position_1 : undefined,
        own_position_2: values.own_position_2 ? values.own_position_2 : undefined,
        customersOwnHave5: values.customersOwnHave5 ? values.customersOwnHave5 : undefined,
        informationAboutoOners: values.informationAboutoOners
          ? values.informationAboutoOners
          : undefined,
        bo_fullname: values.bo_fullname ? values.bo_fullname : undefined,
        bo_nationality: values.bo_nationality ? values.bo_nationality : undefined,
        bo_idno: values.bo_idno ? values.bo_idno : undefined,
        bo_home_addr: values.bo_home_addr ? values.bo_home_addr : undefined,
        bo_conct_addr: values.bo_conct_addr ? values.bo_conct_addr : undefined,
        bo_job: values.bo_job ? values.bo_job : undefined,
        bo_position: values.bo_position ? values.bo_position : undefined,
        bo_phone_no: values.bo_phone_no ? values.bo_phone_no : undefined,
        bo_visa_no: values.bo_visa_no ? values.bo_visa_no : undefined,
        bo_visano_iss_orga: values.bo_visano_iss_orga ? values.bo_visano_iss_orga : undefined,
        bo_foreign_residence: values.bo_foreign_residence ? values.bo_foreign_residence : undefined,
        bank_acnt_no_2: values.bank_acnt_no_2 ? values.bank_acnt_no_2 : undefined,
        bank_acnt_no_3: values.bank_acnt_no_3 ? values.bank_acnt_no_3 : undefined,
        mng_emp_no: values.mng_emp_no ? values.mng_emp_no : undefined,
        idno_expr_dt: !eKYCRes?.ocr.object.valid_date
          ? undefined
          : eKYCRes?.ocr.object.valid_date === 'Không thời hạn'
          ? '30000101'
          : formatBirth(eKYCRes?.ocr.object.valid_date),
      })
        .then((res: any) => {
          if (res.success) {
            showToast(res.error_desc, 1500, 'success')
            // ============================================================
            // LOG STEP 11 — "Hoàn thành mở tài khoản"
            // Trigger: updateAccount thành công
            // Data: toàn bộ values form (TODO: cần trade lại để chỉ gửi fields cần thiết)
            // ============================================================
            // logStep(11, values)
             logStep(11, {
              isFinal: "Hoàn thành mở tài khoản",
             })
            // ============================================================
            // LOG STEP 12 — "Xác nhận đồng ý điều khoản"
            // Trigger: updateAccount thành công (cùng lúc với step 11)
            // Data: nội dung điều khoản đã đồng ý
            // ============================================================
            logStep(12, {
              isAgree:
                'Tôi đã đọc và đồng ý với các điều khoản Hợp đồng mở và sử dụng tài khoản tại Chứng khoán NH Việt Nam',
            })
            uploadCccd(formDataFront)
              .then((res) => {
                if (res) {
                  uploadCccd(formDataBack)
                    .then((res) => {
                      if (res) {
                        callAPIWithDelay()
                      }
                    })
                    .catch((error) => {
                      console.log(error)
                      Swal.fire({
                        title: 'Liên hệ admin',
                        html: `Vui lòng liên hệ NHSV theo số <b>19001055</b> để biết thêm chi tiết.`,
                        allowOutsideClick: false,
                        icon: 'error',
                        confirmButtonText: 'Đã hiểu',
                      })
                    })
                }
              })
              .catch((error) => {
                showToast('Liên hệ Admin', 1500, 'error')
                console.log(error)
                Swal.fire({
                  title: 'Liên hệ admin',
                  html: `Vui lòng liên hệ NHSV theo số <b>19001055</b> để biết thêm chi tiết.`,
                  allowOutsideClick: false,
                  icon: 'error',
                  confirmButtonText: 'Đã hiểu',
                }).then((result) => {
                  if (result.isConfirmed) {
                    stepper.current.goto(1)
                    actions.resetForm()
                  }
                })
              })
          } else {
            Swal.fire({
              title: res.error_desc || 'Liên hệ admin',
              allowOutsideClick: false,
              html: `Tài khoản chưa được khởi tạo thành công. Vui lòng liên hệ NHSV theo số
                <b>19001055</b>
               để được hỗ trợ.`,
              icon: 'error',
              confirmButtonText: 'Đã hiểu',
            }).then((result) => {
              if (result.isConfirmed) {
                // eslint-disable-next-line no-restricted-globals
                location.reload()
                removeCookie('SESSION_ID')
              }
            })
          }
        })
        .catch((error: any) => {
          if (error.response.status === 400) {
            showToast('Liên hệ Admin', 1500, 'error')
            Swal.fire({
              title: error.response.data.error_desc,
              allowOutsideClick: false,
              html: `Tài khoản chưa được khởi tạo thành công. Vui lòng liên hệ NHSV theo số
                <b>19001055</b>
               để được hỗ trợ.`,
              icon: 'error',
              confirmButtonText: 'Đã hiểu',
            }).then((result) => {
              if (result.isConfirmed) {
                // eslint-disable-next-line no-restricted-globals
                location.reload()
                removeCookie('SESSION_ID')
              }
            })
            setActiveStep(true)
          } else {
            Swal.fire({
              allowOutsideClick: false,
              html: `Tài khoản chưa được khởi tạo thành công. Vui lòng liên hệ NHSV theo số
                <b>19001055</b>
               để được hỗ trợ.`,
              icon: 'error',
              confirmButtonText: 'Đã hiểu',
            }).then((result) => {
              if (result.isConfirmed) {
                // eslint-disable-next-line no-restricted-globals
                location.reload()
                removeCookie('SESSION_ID')
              }
            })
          }
          setLoading1(true)
          // stepper.current.goto(1)
          // actions.resetForm()
        })

      // stepper.current.goto(1)
      // actions.resetForm()
    }
    asd = false
    // currentSteps(stepper.current, values, actions)
    setSubmitButton(stepper.current.currentStepIndex === stepper.current.totalStepsNumber)
    setCurrentSchema(createAccountSchemas[stepper.current.currentStepIndex - 1])
  }
  const buildFormData = (file: any, imgKind: string, idno: string) => {
    const formData = new FormData()
    valueOSSEQ && formData.append('seq_no', valueOSSEQ)
    formData.append('id_no', idno)
    formData.append('img_kind', imgKind)
    formData.append('file', file)
    formData.append('lastModified', file?.lastModified)
    formData.append('lastModifiedDate', file?.lastModifiedDate)
    formData.append('name', file?.name)
    formData.append('size', file?.size)
    formData.append('type', file?.type)
    return formData
  }
  const handleChangeOTP = useCallback(async (e: any) => {
    if (e?.length === 6) {
      setGetValOtp(e)
      setActiveStep(false)
    } else {
      setActiveStep(true)
    }
  }, [])

  const confirmOTP = () => {
    // console.log('confirm')
  }

  // useCallback + logStep dep → stable reference → useEffect([onGetData, resEKYC]) in Step7ScanFace
  // only fires when resEKYC changes, not on every Registration re-render. Fixes step 6 duplicate calls.
  const handleChildScanRes = useCallback((childData: any) => {
    seteKYCRes(childData)
    if (childData) {
      const idno = childData?.ocr?.object?.id
      if (idno) userContactRef.current = {...userContactRef.current, idno}
      // ============================================================
      // LOG STEP 6 — "Quét khuôn mặt eKYC"
      // Trigger: Step7ScanFace hoàn tất eKYC, gọi callback onGetData
      // Data: toàn bộ response từ VNPT (OCR, liveness, face compare, base64 ảnh)
      //       (TODO: cần trade lại để chỉ gửi fields cần thiết, bỏ base64)
      // ============================================================
      logStep(6, childData)
    }
  }, [logStep])

  useEffect(() => {
    if (!stepperRef.current && isVietNam) {
      return
    }

    loadStepper()
  }, [isVietNam, stepperRef])

  const handleGetCheckFinalStep = (val: any) => {
    setCheckedFinal(val)
  }

  const handleModal = (val: any) => {
    setSubmitModal(val)
  }

  const handleGetNameInfo = (val: any) => {
    setGetValInfo(val)
  }

  const handleGetNameCare = (val: any) => {
    setGetValCare(val)
  }

  function onChangeHandler(code: any) {
    const bank: any = listBank?.find(function (item: any) {
      return item.code === code
    })

    if (bank) {
      return bank.code_nm
    } else {
      return null
    }
  }

  function onChangeHandlerBr(code: any) {
    if (listBankBr) {
      const bank: any = listBankBr[0]?.find(function (item: any) {
        return item.code === code
      })

      if (bank) {
        return bank.code_nm
      } else {
        return null
      }
    }
  }
  function onChangeHandlerBr1(code: any) {
    if (listBankBr) {
      const bank: any = listBankBr[1]?.find(function (item: any) {
        return item.code === code
      })

      if (bank) {
        return bank.code_nm
      } else {
        return null
      }
    }
  }
  function onChangeHandlerBr2(code: any) {
    if (listBankBr) {
      const bank: any = listBankBr[2]?.find(function (item: any) {
        return item.code === code
      })

      if (bank) {
        return bank.code_nm
      } else {
        return null
      }
    }
  }

  const handleGetListBank = (val: any) => {
    setListBank(val)
  }

  const handleGetListBankBr = (val: any) => {
    setListBankBr(val)
  }

  useEffect(() => {
    if (isSubmitButton) {
      setActiveStep(true)
    }
    if (checkedFinal) {
      setActiveStep(false)
    }
  }, [checkedFinal, isSubmitButton])

  return (
    <>
      {isVietNam ? (
        <Step1 setIsVietNam={setIsVietNam} />
      ) : (
        <div
          className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
          style={{
            // backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
            backgroundColor: 'rgb(235 243 243)',
          }}
        >
          <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
            <div className='mb-12'>
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/logos/nhsv-logo-horizontal-light.svg')}
                className='h-45px'
              />
            </div>
            <div className='w-lg-1000px bg-body rounded shadow-sm p-lg-15 mx-auto'>
              <div className='card card-containers'>
                <div className='card-body'>
                  <div
                    ref={stepperRef}
                    className='stepper stepper-links d-flex flex-column pt-15'
                    id='kt_create_account_stepper'
                  >
                    <div className='stepper-nav mb-5'>
                      <div className='stepper-item current' data-kt-stepper-element='nav'>
                        {stepper?.current?.steps[0].classList.contains('current') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : stepper?.current?.steps[1].classList.contains('completed') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-done.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC.png')}
                            className='h-20px h-lg-30px'
                          />
                        )}
                      </div>

                      <div data-kt-stepper-element='nav'></div>

                      <div className='stepper-item' data-kt-stepper-element='nav'>
                        {stepper?.current?.steps[2].classList.contains('current') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-2-current.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : stepper?.current?.steps[3].classList.contains('current') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-2-current.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : stepper?.current?.steps[4].classList.contains('current') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-2-current.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : stepper?.current?.steps[5].classList.contains('current') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-2-current.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : stepper?.current?.steps[5].classList.contains('completed') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-2-done.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-2.png')}
                            className='h-20px h-lg-30px'
                          />
                        )}
                      </div>

                      <div data-kt-stepper-element='nav'></div>

                      <div data-kt-stepper-element='nav'></div>

                      <div data-kt-stepper-element='nav'></div>

                      <div className='stepper-item' data-kt-stepper-element='nav'>
                        {stepper?.current?.steps[6].classList.contains('current') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-3-current.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : stepper?.current?.steps[7].classList.contains('current') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-3-current.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : stepper?.current?.steps[8].classList.contains('current') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-3-current.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : stepper?.current?.steps[8].classList.contains('completed') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-3-done.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-3.png')}
                            className='h-20px h-lg-30px'
                          />
                        )}
                      </div>

                      <div data-kt-stepper-element='nav'></div>

                      <div data-kt-stepper-element='nav'></div>

                      <div className='stepper-item' data-kt-stepper-element='nav'>
                        {stepper?.current?.steps[9].classList.contains('current') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-4-current.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : stepper?.current?.steps[9].classList.contains('completed') ? (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-4-done.png')}
                            className='h-20px h-lg-30px'
                          />
                        ) : (
                          <img
                            alt='Logo'
                            src={toAbsoluteUrl('/media/nhsv/eKYC-4.png')}
                            className='h-20px h-lg-30px'
                          />
                        )}
                      </div>
                    </div>

                    <Formik
                      validationSchema={currentSchema}
                      initialValues={initValues}
                      onSubmit={submitStep}
                    >
                      {({setFieldValue, getFieldProps, errors}) => (
                        <Form
                          className='mx-auto mw-600px w-100 pt-5 pb-10 form_nhsv'
                          id='kt_create_account_form'
                        >
                          {/* <GoogleReCaptcha onVerify={handleVerify} /> */}
                          <div className='current' data-kt-stepper-element='content'>
                            <Step2 errors={errors} setActiveStep={setActiveStep} />
                          </div>

                          <div data-kt-stepper-element='content'>
                            {acitveStepOTP && (
                              <OTP
                                // numberPhone='0912345678'
                                changeOTPEvent={handleChangeOTP}
                                isError={checkOtp}
                                // handleResendOtp={handleChangeOTP}
                                currentStep={currentStep}
                                valueSteps={valueSteps}
                                checkOtpSucc={checkOtpSucc}
                                emptyOtp={emptyOtp}
                              />
                            )}
                          </div>

                          <div data-kt-stepper-element='content'>
                            <Step4 />
                          </div>

                          <div data-kt-stepper-element='content'>
                            <Step7 />
                          </div>

                          <div data-kt-stepper-element='content'>
                            <Step7ScanFace
                              onGetData={handleChildScanRes}
                              setActiveStep={setActiveStep}
                              getTokenVNPT={getTokenVNPT}
                              stepper={stepper}
                              mobile={valueSteps?.phoneNumber}
                            />
                          </div>

                          <div data-kt-stepper-element='content'>
                            <Step6
                              eKYCRes={eKYCRes}
                              setActiveStep={setActiveStep}
                              setFieldValue={setFieldValue}
                            />
                          </div>

                          <div data-kt-stepper-element='content'>
                            <Step8
                              isActive={stepIndex === 7}
                              setActiveStep={setActiveStep}
                              handleGetNameInfo={handleGetNameInfo}
                              handleGetNameCare={handleGetNameCare}
                              setFieldValue={setFieldValue}
                              getFieldProps={getFieldProps}
                              errors={errors}
                            />
                          </div>

                          <div data-kt-stepper-element='content'>
                            {asdBank && (
                              <Step9
                                setActiveStep={setActiveStep}
                                eKYCRes={eKYCRes}
                                handleGetListBank={handleGetListBank}
                                handleGetListBankBr={handleGetListBankBr}
                                setFieldValue={setFieldValue}
                              />
                            )}
                          </div>

                          <div data-kt-stepper-element='content'>
                            <Step10 setFieldValue={setFieldValue} />
                          </div>

                          <div data-kt-stepper-element='content'>
                            <Step11
                              handleGetCheckFinalStep={handleGetCheckFinalStep}
                              setActiveStep={setActiveStep}
                            />
                          </div>

                          <div className='d-flex flex-stack pt-15'>
                            <div className='mr-2'>
                              <button
                                onClick={prevStep}
                                disabled={disableStep}
                                type='button'
                                className='btn btn-lg btn-light-primary me-3'
                                data-kt-stepper-action='previous'
                              >
                                <KTIcon iconName='arrow-left' className='fs-4 me-1' />
                                Quay lại
                              </button>
                            </div>

                            <div>
                              <button
                                type='submit'
                                disabled={activeStep || loading}
                                className='btn btn-lg btn-primary me-3'
                                data-bs-toggle={
                                  (isSubmitButton && checkedFinal) || loading1 ? 'modal' : ''
                                }
                                data-bs-target={
                                  (isSubmitButton && checkedFinal) || loading1 ? '#kt_modal_1' : ''
                                }
                              >
                                <span className='indicator-label'>
                                  <span>{isSubmitButton ? 'Hoàn thành' : 'Tiếp theo'}</span>
                                  {loading ? (
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                  ) : (
                                    <KTIcon iconName='arrow-right' className='fs-3 ms-2 me-0' />
                                  )}
                                </span>
                              </button>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalReaded handleModal={handleModal} eKYCRes={eKYCRes} loading={loading} />
    </>
  )
}

export {Registration}
